import CalendarViewDayIcon from "@mui/icons-material/CalendarViewDay";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PinIcon from "@mui/icons-material/Pin";
import ShuffleIcon from "@mui/icons-material/Shuffle";
import ConstructionIcon from "@mui/icons-material/Construction";
import PendingActionsIcon from "@mui/icons-material/PendingActions";

export function MonthIcon(props) {
  return <CalendarMonthIcon {...props} />;
}

export function DayIcon(props) {
  return <CalendarViewDayIcon {...props} />;
}

// vakio = muuttuja = constant
export function VakioIcon(props) {
  return <PinIcon {...props} />;
}
export function RandomIcon(props) {
  return <ShuffleIcon {...props} />;
}

export function WorkIcon(props) {
  return <ConstructionIcon {...props} />;
}

export function CapacityIcon(props) {
  return <PendingActionsIcon {...props} />;
}
